export default __webpack_public_path__ + "static/media/695.debc8916.png";